import { useQuery } from '@tanstack/react-query';
import { assetsApi, type AssetCategory } from '../services/assetsApi';
import { queryKeys } from '@/lib/queryKeys';

export const useAssetCategories = () => {
  const { data: categories = [], isLoading, error } = useQuery<AssetCategory[], Error>({
    queryKey: queryKeys.assetCategories.all(),
    queryFn: () => assetsApi.listCategories(),
    staleTime: 5 * 60_000,
  });

  return { categories, isLoading, error: error ? error.message : null };
};
